import { type IWriteQuery, Looker40SDK } from '@looker/sdk';

export const query = (looker: Looker40SDK) => ({
  from: <F extends Record<string, any>>(body: IWriteQuery) => ({
    toMany: async <R>(
      transformer: (fields: F, index: number, results: F[]) => R,
    ): Promise<R[]> => {
      // @ts-expect-error - run_inline_query type always return a string even if an array is returned
      const results: D[] = await looker.ok(
        looker.run_inline_query({ result_format: 'json', body }),
      );

      return results.map((result, index, results) =>
        transformer(result, index, results),
      );
    },
    toFirst: async <R>(transformer: (fields: F) => R): Promise<R> => {
      // @ts-expect-error - run_inline_query type always return a string even if an array is returned
      const results: D[] = await looker.ok(
        looker.run_inline_query({
          result_format: 'json',
          body: { ...body, limit: '1' },
        }),
      );

      const [firstResult] = results ?? [];

      if (!firstResult) {
        throw new Error('No results found');
      }

      return transformer(firstResult);
    },
    toFirstOrUndefined: async <R>(
      transformer: (fields: F) => R,
    ): Promise<R | undefined> => {
      // @ts-expect-error - run_inline_query type always return a string even if an array is returned
      const results: D[] = await looker.ok(
        looker.run_inline_query({
          result_format: 'json',
          body: { ...body, limit: '1' },
        }),
      );

      const [firstResult] = results ?? [];

      if (!firstResult) {
        return undefined;
      }

      return transformer(firstResult);
    },
  }),
});

export const containsValues = (values: string[]): string => values.join(',');
